// Module
var code = "<div ng-repeat=\"cat in vm.categories\"> <h3>{{cat.Name}}</h3> <ul> <li ng-repeat=\"child in cat.Children\"><label><input ng-click=\"vm.change(child.Id,child.Name)\" value=\"{{child.Id}}\" type=\"checkbox\"/><span></span> {{child.Name}}</label></li> </ul> </div>";
// Exports
module.exports = code;